import React, { useContext } from 'react';
import { Grid } from '@wds/grid';
import { Box } from '@wds/box';
import classnames from 'classnames';
import { LanguageListLO } from './LanguageMenu';
import { AnonFooterLinks } from './FooterLinks';
import TrusteSeals from './TrusteSeals';
import CopyRight from './CopyRight';
import { SMFooterContext } from './SMFooterContext';

import useStyles from './useStyles';

const AnonFooter = () => {
  const { variant } = useContext(SMFooterContext);

  const { footerAnon, fullHeight, footerBorder } = useStyles();

  const TrusteFooterSeals = () => {
    return (
      <Grid.Item md={5}>
        <Box display="flex" flexJustify="flex-end" flexAlign="center">
          <TrusteSeals />
        </Box>
      </Grid.Item>
    );
  };

  const footerClassNames = classnames(footerAnon, 'sm-footer');

  return (
    <div className={footerClassNames} data-testid="AnonFooter">
      <Choose>
        <When condition={variant === 'default'}>
          <Grid>
            <Grid.Item>
              <div className={footerBorder}>
                <AnonFooterLinks />
              </div>
            </Grid.Item>
          </Grid>
          <Grid>
            <Grid.Item>
              <Box className={footerBorder} py={4}>
                <LanguageListLO />
              </Box>
            </Grid.Item>
          </Grid>
          <Grid>
            <Grid.Item md={7}>
              <Box display="flex" flexAlign="center" className={fullHeight}>
                <CopyRight />
              </Box>
            </Grid.Item>
            {TrusteFooterSeals()}
          </Grid>
        </When>
        <Otherwise>
          <Grid>
            <Grid.Item md={7}>
              <Box
                display="flex"
                flexDirection={variant === 'default' ? 'row' : 'column'}
                flexAlign={variant === 'default' ? 'center' : 'flex-start'}
                flexJustify={variant === 'default' ? 'flex-start' : 'center'}
                className={fullHeight}
              >
                <AnonFooterLinks />
                <CopyRight />
              </Box>
            </Grid.Item>
            {TrusteFooterSeals()}
          </Grid>
        </Otherwise>
      </Choose>
    </div>
  );
};

export default AnonFooter;
